import moment from 'moment';
import { Directive, ElementRef, inject } from '@angular/core';
import { NG_VALIDATORS, UntypedFormControl, Validator } from '@angular/forms';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[dateValidation]',
    providers: [{ provide: NG_VALIDATORS, useExisting: DateValidatorDirective, multi: true }],
})
export class DateValidatorDirective implements Validator {
    public readonly el = inject(ElementRef);

    static validateDate(c: UntypedFormControl): { [key: string]: any } {
        const format = 'YYYY-MM-DD';
        const val = moment(c.value, format, true);

        if (!val.isValid()) {
            return { date: true };
        }

        return null;
    }

    validate(c: UntypedFormControl): { [key: string]: any } {
        return DateValidatorDirective.validateDate(c);
    }
}
